export default __webpack_public_path__ + "static/concerts-bg-980b929c35d9d61891772a49d8ef920c.jpg";